import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from 'vue'
import BaseButton from '@/components/BaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollWrapper',
  props: {
  buttonClasses: {
    type: [Array, Object, String],
    default: undefined,
  },
  scrollAmount: {
    type: Number,
    default: 100,
  },
},
  setup(__props) {

const props = __props



const scrollWrapper = ref<HTMLElement>(null as unknown as HTMLElement)
const content = ref<HTMLElement>(null as unknown as HTMLElement)

const scrollPosition = ref<number>(0)
const maxScroll = ref<number>(0)
const showLeftButton = ref<boolean>(false)
const showRightButton = ref<boolean>(false)

const updateScrollPosition = () => {
  scrollPosition.value = scrollWrapper.value.scrollLeft
  showLeftButton.value = scrollPosition.value > 0
  showRightButton.value = scrollPosition.value < maxScroll.value
}

const scrollLeft = () => {
  scrollWrapper.value.scrollLeft -= props.scrollAmount
  updateScrollPosition()
}

const scrollRight = () => {
  scrollWrapper.value.scrollLeft += props.scrollAmount
  updateScrollPosition()
}

onMounted(() => {
  updateScroll()
  window.addEventListener('resize', updateScroll)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateScroll)
})

const updateScroll = () => {
  const contentWidth = content.value.scrollWidth
  const wrapperWidth = scrollWrapper.value.clientWidth
  maxScroll.value = contentWidth - wrapperWidth
  updateScrollPosition()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollWrapper",
    ref: scrollWrapper,
    class: "scroll-wrapper",
    onScroll: updateScrollPosition
  }, [
    _createElementVNode("div", {
      ref_key: "content",
      ref: content,
      class: "content"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    _withDirectives(_createVNode(BaseButton, {
      icon: "chevron-left",
      "icon-size": 40,
      class: _normalizeClass(["scroll-button left", __props.buttonClasses]),
      onClick: scrollLeft
    }, null, 8, ["class"]), [
      [_vShow, showLeftButton.value]
    ]),
    _withDirectives(_createVNode(BaseButton, {
      icon: "chevron-right",
      "icon-size": 40,
      class: _normalizeClass(["scroll-button right", __props.buttonClasses]),
      onClick: scrollRight
    }, null, 8, ["class"]), [
      [_vShow, showRightButton.value]
    ])
  ], 544))
}
}

})